export interface LimsSamplingPoint {
  id: number
  code: string
  description?: string
  samplingPoint?: SamplingPoint
}

export interface SamplingPoint {
  id: number
  type: string
  assetId?: number
  grindingCircuitId?: number
  storageId?: number
  limsSamplingPointId: number
  upmDepartmentId?: string
}

export interface SamplingPointCounts {
  limsSamplingPointCode: string
  limsSamplingPointDescription: string
  sampleCount: number
}

export type SamplingPointsCountsMap = Map<string, number>

export enum SamplingPointEquipmentType {
  asset = 'Asset',
  storage = 'Storage',
  other = 'Other'
}

export interface SamplingPointType {
  id: number
  name: string
  equipmentType: SamplingPointEquipmentType
}

export enum EquipmentOptionType {
  asset = 'asset',
  grindingCircuit = 'grindingCircuit',
  storage = 'storage'
}

export interface EquipmentOption {
  id: number
  label: string
  type: EquipmentOptionType
}

export type SamplingPointTypeOption = Omit<EquipmentOption, 'type'> & {
  type: SamplingPointEquipmentType
}

export interface UpmDepartment {
  id: string
  label: string
}

export interface RowData {
  typeOption: SamplingPointTypeOption | null
  equipmentOption: EquipmentOption | null
  upmDepartmentOption: UpmDepartment | null
}

export enum SortDirection {
  ASCENDING = 'ascending',
  DESCENDING = 'descending'
}

export enum SortByColumn {
  CODE = 'code',
  COUNTS = 'counts'
}
